(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	require('smooth-scroll');

	$('[data-smooth-scroll]').smoothScroll({
		//offset: window.matchMedia('(min-width: 1080px)').matches ? -100 : -75
		offset: window.matchMedia('(min-width: 1080px)').matches ? -100 : -75
	});

	$('[data-smooth-scroll-2]').smoothScroll({
		offset: window.matchMedia('(min-width: 1080px)').matches ? -160 : -140
	});
})();
